export default __webpack_public_path__ + "static/media/elevate-blk-poster-2.bc548120.jpg";